import requestFunctions from "../../functions/requestFunctions";

export const state = {

}

export const getters = {

}

export const mutations = {

}


export const actions = {

  async FETCH_PAYMENTS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/payments';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}